/* eslint-disable one-var */
import { Component } from '@verndale/core';
import PrimaryNav from './primary-nav';
import Search from './search';

class Header extends Component {
  setupDefaults() {
    this.dom = {
      menuTrigger: this.el.querySelector('.menu-trigger'),
      navWrapper: this.el.querySelector('.nav-wrapper__row'),
      primaryNav: this.el.querySelector('.primary-nav'),
      search: this.el.querySelector('.header-search'),
      mobileChatTrigger: this.el.querySelector('.js-mobile-chat-trigger'),
      rifPartial: document.querySelector('.rif-partial'),
      rif: document.querySelector('.rif'),
      hero: document.querySelector('.page *:first-child')
    };

    if (this.dom.primaryNav) {
      this.primaryNav = new PrimaryNav(this.dom.primaryNav, {
        relativeEl: this.dom.navWrapper
      });
    }

    if (this.dom.search) {
      new Search(this.dom.search);
    }

    this.waitForMobileChatElement();
  }

  addListeners() {
    if (this.dom.menuTrigger && this.dom.primaryNav) {
      this.dom.menuTrigger.addEventListener('click', ::this.togglePrimaryNav);
    }

    window.addEventListener('scroll', ::this.handleScroll);
  }

  handleScroll() {
    const currentScroll = document.documentElement.scrollTop;
    const headerHeight = this.el.clientHeight;

    if (currentScroll < headerHeight) {
      this.el.classList.remove('header--sticky');
      return;
    }

    this.el.classList.add('header--sticky');
  }

  displayMobileChatTrigger() {
    const mobileChat = document.querySelector('.wsa_dock');
    const scrollY = window.scrollY + 60;
    const scrollYBottom = scrollY + window.innerHeight;
    let showAfter = this.dom.hero.offsetTop + this.dom.hero.offsetHeight,
      heroNextSibling = this.dom.hero.nextSibling;
    while (heroNextSibling && heroNextSibling.nodeType !== 1) {
      heroNextSibling = heroNextSibling.nextSibling;
    }
    if (heroNextSibling.classList.contains('rif-partial')) {
      showAfter =
        this.dom.rifPartial.offsetTop + this.dom.rifPartial.offsetHeight;
    }

    let showMobileChatElement = scrollY >= showAfter;
    let disableOnRifPartial = true;
    if (this.dom.rifPartial) {
      const rifTop = this.dom.rifPartial.offsetTop;
      const rifBottom =
        this.dom.rifPartial.offsetTop + this.dom.rifPartial.offsetHeight;
      disableOnRifPartial = !(
        scrollYBottom >= rifTop && scrollY + 200 <= rifBottom
      );
    }
    if (this.dom.rif) {
      const rifTop = this.dom.rif.offsetTop;
      const rifBottom = this.dom.rif.offsetTop + this.dom.rif.offsetHeight;
      showMobileChatElement =
        (showMobileChatElement && scrollYBottom <= rifTop + 100) ||
        scrollY >= rifBottom;
    }

    if (showMobileChatElement && disableOnRifPartial) {
      mobileChat.classList.remove('inactive');
    } else {
      mobileChat.classList.add('inactive');
    }
  }

  waitForMobileChatElement() {
    const addCustomLogicToMobileChatElement = () => {
      if ($('.wsa_dock').length) {
        // eslint-disable-next-line no-undef
        clearInterval(interval);
        this.displayMobileChatTrigger();
        window.addEventListener('scroll', ::this.displayMobileChatTrigger);
      }
    };
    // eslint-disable-next-line no-undef
    const interval = setInterval(addCustomLogicToMobileChatElement, 500);
  }

  togglePrimaryNav() {
    this.primaryNav.open();

    const isFoundation = document.querySelector('body').getAttribute('data-site') === 'foundation';
    if (!isFoundation) return;

    // Wait for CSS styles to be applied before clicking nav button
    // (pointer-events changes from none to auto after class addition)
    window.requestAnimationFrame(() => {
      this.primaryNav.dom.navButtons[0].click();
    });
  }
}

export default Header;
